/**
 * Created by stonewang on 2018/2/19.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Card, Button, Modal, Form, Switch, Input, message} from 'antd';
import {
	addressList,
	saveOrModifyAddress,
	deleteAddress,
	defaultAddress,
	getDefaultAddress as currentAddress
} from '../../service/account';
import {checkPhone} from '../../utils/regexp'
const FormItem = Form.Item;
import {RegionCascader} from '../../components';

class Address extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			editFlag: false,
			showAllFlag: false,
			list: [],
			detail: {},
			defaultAddress: {},
			applyFlag: window.location.href.indexOf('apply') > -1 ? true : false //是否退换货
		};
		this.onAdd = this.onAdd.bind(this);
		this.onEdit = this.onEdit.bind(this);
		this.getData = this.getData.bind(this);
		this.handleOk = this.handleOk.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.getAddressList = this.getAddressList.bind(this);
		this.showAllFlagChange = this.showAllFlagChange.bind(this);
		this.setDefaultAddress = this.setDefaultAddress.bind(this);
		this.getDefaultAddress = this.getDefaultAddress.bind(this);
		this.getCurrentAddress = this.getCurrentAddress.bind(this);
		this.returnDefaultAddress = this.returnDefaultAddress.bind(this);
	}
	
	componentDidMount() {
		this.getData();
		this.props.getNode && this.props.getNode(this);
	}
	
	getData() {
		addressList().then(res => {
			if (res.status) {
				var list = [];
				list = res.data.map((x, i) => ({
					...x,
					isCurrent: x.isDefault == 1
				}));
				this.setState({
					...this.state,
					list: this.state.applyFlag ? list : ((res.data && Array.isArray(res.data)) ? res.data : []),
					detail: {},
					editFlag: false
				})
			}
		});
		this.getDefaultAddress().then(data => {
			if (this.props.onChange) {
				this.props.onChange(data)
			}
		})
	}
	
	getAddressList() {
		addressList().then(res => {
			if (res.status) {
				this.setState({
					...this.state,
					list: res.data || [],
					detail: {},
					editFlag: false
				})
			}
		});
	}
	
	onEdit(index, e) {
		e.preventDefault();
		e.stopPropagation();
		const data = {...this.state.list[index]};
		data.oldShippingAddress = data.shippingAddress;
		data.oldAddress = `${data.province || ''}${data.city || ''}${data.county || ''}`;//${data.oldShippingAddress||''};
		data.shippingAddress = data.oldShippingAddress;
		
		this.setState({
			...this.state,
			detail: data,
			editFlag: true,
		})
	}
	
	onAdd() {
		this.props.form.resetFields();
		this.setState({
			...this.state,
			editFlag: true,
			detail: {},
		})
	}
	
	onDelete(index, e) {
		e.preventDefault();
		e.stopPropagation();
		const data = this.state.list[index];
		deleteAddress(data.id).then(res => {
			message[res.status ? 'success' : 'error'](res.message);
			res.status && this.getData();
		});
	}
	
	handleCancel() {
		this.props.form.resetFields();
		this.setState({...this.state, editFlag: false, detail: {}});
	}
	
	setDefaultAddress(id) {
		defaultAddress(id).then(res => {
			message[res.status ? 'success' : 'error'](res.message);
			res.status && this.getData();
		})
	}
	
	setCurrentAddress(id, index) {
		let {list} = this.state;
		list = list.map((x, i) => ({
			...x,
			isCurrent: index === i
		}));
		this.setState({
			...this.state,
			list,
			currentAddress: {...list[index]}
		});
	}
	
	getCurrentAddress() {
		return new Promise((resolve, reject) => {
			resolve(this.state.currentAddress)
		})
	}
	
	getDefaultAddress() {
		return new Promise((resolve, reject) => {
			currentAddress().then(res => {
				this.setState({
					defaultAddress: {
						...this.state.defaultAddress,
						...res.data
					},
					currentAddress: {
						...this.state.currentAddress,
						...res.data
					}
				})
				resolve(res.data);
			});
		})
	}
	
	returnDefaultAddress() {
		if (this.props.getDefault) {
			this.props.getDefault(this.state.defaultAddress);
		}
	}
	
	handleOk() {
		const {detail} = this.state;
		const {validateFields, getFieldsValue, resetFields} = this.props.form;
		validateFields((errors) => {
			if (errors) {
				return
			}
			let data = getFieldsValue();
			data.isDefault = !!data.isDefault ? 1 : 0;
			console.log(JSON.stringify({...detail, ...data}));
			if (detail.id) {
				data = {...data, id: detail.id}
			}
			if (data.userDiv && data.userDiv.selectedOptions && Array.isArray(data.userDiv.selectedOptions)) {
				data.userDiv.selectedOptions.forEach(x => {
					let key = ['province', 'city', 'county'];
					data[key[x.level - 1]] = x.regionName;
				})
			}
			delete data.userDiv;
			data.province = data.province || detail.province;
			data.city = data.city || detail.city;
			data.county = data.county || detail.county;
			data.shippingAddress = data.shippingAddress || detail.oldShippingAddress;
			
			saveOrModifyAddress(data).then(res => {
				message[res.status ? 'success' : 'error'](res.message);
				resetFields();
				res.status && this.getData();
			})
		})
	}
	
	showAllFlagChange() {
		this.setState({showAllFlag: !this.state.showAllFlag})
	}
	
	render() {
		const {editFlag, detail, list, showAllFlag, applyFlag} = this.state;
		const {getFieldDecorator} = this.props.form;
		const {bordered, btnStyle, className, componentStyle, cardClassName, title, limit} = this.props;
		const formItemLayout = {
			labelCol: {
				span: 4
			},
			wrapperCol: {
				span: 16
			},
			colon: false,
			hasFeedback: true,
			className: 'dms-form-item'
		};
		return <div className={className} style={{...componentStyle}}>
			<Card title={title}
				  noHovering
				  bordered={bordered}
				  className={`addressList ${cardClassName}`}
				  bodyStyle={{padding: '12px', minHeight: '207px'}}
				  extra={<Button type="primary" style={{...btnStyle}} onClick={this.onAdd}>新增收货地址</Button>}>
				{!list.length && <div className="cusNoDataBig">暂无数据</div> }
				{
					list.map((item, index) => {
						if (!limit || showAllFlag) {
							return <Card.Grid key={index}>
								<Card title={item.recipientName}
									  noHovering
									  onClick={this.setCurrentAddress.bind(this, item.id, index)}
									  className={!!item.isCurrent ? 'currentAddress' : ''}
									  bodyStyle={{padding: '12px', height: '110px'}}
									  extra={<span>
                    <b onClick={this.onEdit.bind(this, index)}>编辑</b>
										  {
											  applyFlag ?
												  (
													  !item.isDefault ?
														  <b onClick={this.onDelete.bind(this, index)}>删除</b>
														  :
														  ''
												  )
												  :
												  <b onClick={this.onDelete.bind(this, index)}>删除</b>
										  }
                  </span>}>
									<h4>{item.recipientName} {item.mobile}</h4>
									<p>{`${item.province || ''}${item.city || ''}${item.county || ''}`} {item.shippingAddress}</p>
								</Card>
							</Card.Grid>
						} else if (index < limit) { //limit>0 && showAllFlag===false
							return <Card.Grid key={index}>
								<Card title={item.recipientName}
									  noHovering
									  onClick={this.setCurrentAddress.bind(this, item.id, index)}
									  className={!!item.isCurrent ? 'currentAddress' : ''}
									  bodyStyle={{padding: '12px', height: '110px'}}
									  extra={<span>
                    <b onClick={this.onEdit.bind(this, index)}>编辑</b>
										  {
											  applyFlag ?
												  (
													  !item.isDefault ?
														  <b onClick={this.onDelete.bind(this, index)}>删除</b>
														  :
														  ''
												  )
												  :
												  <b onClick={this.onDelete.bind(this, index)}>删除</b>
										  }
                  </span>}>
									<h4>{item.recipientName} {item.mobile}</h4>
									<p>{`${item.province || ''}${item.city || ''}${item.county || ''}`} {item.shippingAddress}</p>
								</Card>
							</Card.Grid>
						}
					})
				}
			</Card>
			{
				!!limit && list.length > 3 && <div className='card-show noBorder' onClick={this.showAllFlagChange}>
					<i className={showAllFlag ? 'comIcon blackArrowUp' : 'comIcon blackArrowDown'}></i>
				</div>
			}
			<Modal width={800}
				   okText="保存"
				   title={`${detail.id ? '编辑' : '新增'}收货地址`}
				   visible={editFlag}
				   onOk={this.handleOk}
				   destroyOnClose={true}
				   onCancel={this.handleCancel}
				   wrapClassName="addressModal">
				<Form>
					<FormItem {...formItemLayout}
							  label="收货人">
						{getFieldDecorator('recipientName', {
							initialValue: detail.recipientName || '',
							rules: [
								{
									required: true,
									message: '请输入收货人姓名'
								},
							],
						})(<Input placeholder="请输入收货人姓名"/>)}
					</FormItem>
					<FormItem {...formItemLayout}
							  label="手机号码">
						{getFieldDecorator('mobile', {
							initialValue: detail.mobile || '',
							rules: [
								{
									required: true,
									message: '请输入手机号码'
								},
								{
									validator: checkPhone
								}
							],
						})(<Input placeholder="请输入手机号码"/>)}
					</FormItem>
					{
						detail.id &&
						<FormItem label="原收货地址" {...formItemLayout}><span>{detail.oldAddress}</span></FormItem>
					}
					<div id="userDivBox">
						<FormItem label="收货地址" {...formItemLayout}>
							{getFieldDecorator('userDiv', {
								rules: [
									{
										required: !detail.id,
										message: '请选择收货地址'
									}
								]
							})(<RegionCascader containerId="userDivBox" placeholder="请选择收货地址"
											   style={{width: '100%'}}/>)}
						</FormItem>
					</div>
					<FormItem {...formItemLayout} label="详细地址">
						{getFieldDecorator('shippingAddress', {
							initialValue: detail.shippingAddress || '',
							rules: [
								{
									required: true,
									message: '请输入详细地址'
								},
							],
						})(<Input placeholder="请输入详细地址"/>)}
					</FormItem>
					<FormItem {...formItemLayout} label="设置为默认">
						{getFieldDecorator('isDefault', {
							valuePropName: 'checked',
							initialValue: !!detail.isDefault,
							rules: [
								{
									required: true,
									message: '请设置是否为默认'
								},
							]
						})(<Switch />)}
					</FormItem>
				</Form>
			</Modal>
		</div>
	}
}
Address.propTypes = {
	limit: PropTypes.number,
	title: PropTypes.node,
	bordered: PropTypes.bool,
	btnStyle: PropTypes.object,
	className: PropTypes.string,
	cardClassName: PropTypes.string,
	componentStyle: PropTypes.object,
	getNode: PropTypes.func,
	onChange: PropTypes.func,
	getDefault: PropTypes.func,
};
Address.defaultProps = {
	limit: null,
	title: '收货信息',
	bordered: true,
	btnStyle: null,
	className: null,
	cardClassName: '',
	componentStyle: null,
	getNode: null,
	onChange: null,
	getDefault: null
}
export default Form.create()(Address)


// WEBPACK FOOTER //
// ./src/mall/userCenter/address.js